export enum Role {
    Admin = 1,
    RiskManager,
    PartnerOrganisationAdmin,
    FinancialRiskAdmin,
    CustomSectionsAdmin
}